export const APPLICATION_STRINGS = {
    PLEASE_LOGIN : 'Please login before placing an order.',
    ORDER_ONE_ITEM : 'Orders must have at least one associated item',
    EMAIL_SENT : "Email Sent!",
    EMAIL_FAILED : "Email failed to send: ",
    SAF_ERROR : "There was an issue syncing offline transactions. Please try again later.",
    TAB_STARTED : "Success! New tab opened.",
    CLOSE_TAB_SUCCEEDED: "Success! Tab Closed.",
    CLOSE_TAB_FAILED: "Error! There was an error closing the tab.",
    TAB_UPDATED: "Success! Tab has been updated.",
    TAB_UPDATE_FAILED: "Error! There was an error adding items to the tab.",
    REFUND_TABBED_ORDER_SUCCEEDED: "Success! Items voided.",
    REFUND_TABBED_ORDER_FAILED: "Error! There was an error voiding order items.",
    REFUND_TABBED_ORDER_CANCELLED: "Order has been cancelled.",
    PROMOTIONS_NOT_APPLIED: "Not all promotions were applied."
}
